

import { useState, useEffect } from 'react';
//import CommentBox from '../../../components/CommentBox/CommentBox';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import axios from 'axios';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Choghadiya.scss';
import MuhuratLink from '../../../components/MuhuratLink/MuhuratLink';
import { Link } from 'react-router-dom';
import city from '../../../city.json'




const Choghadiya = () => {

  const typeTooltips = {
    Amrit: "Most auspicious. Ruled by Moon. Good for all work.",
    Shubh: "Auspicious. Ruled by Jupiter. Best for ceremonies, especially marriages.",
    Labh: "Auspicious. Ruled by Mercury. Best for learning and gaining.",
    Char: "Auspicious. Ruled by Venus. Good for travel.",
    Chal: "Neutral/Auspicious. Flexible time, okay for regular work.",
    Udveg: "Inauspicious. Ruled by Sun. Avoid unless for government-related tasks.",
    Kaal: "Inauspicious. Ruled by Saturn. Avoid for auspicious work.",
    Rog: "Inauspicious. Ruled by Mars. Avoid unless you're defeating enemies.",
  };


  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState("Kolkata");
  const [dayMuhurta, setDayMuhurta] = useState([]);
  const [nightMuhurta, setNightMuhurta] = useState([]);
  const [timeFormat, setTimeFormat] = useState("12"); // "12", "24", or "24Plus"
  const [currentChoghadiya, setCurrentChoghadiya] = useState(null);



  // Temporary states for user input for submit button and location dropdown
  const [tempDate, setTempDate] = useState(currentDate);
  const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);


  useEffect(() => {
    const fetchChoghadiya = async () => {
      const formattedDate = currentDate.toISOString().split('T')[0];

      const getStatus = (type) => {
        const goodTypes = ['Amrit', 'Shubh', 'Labh', 'Chal', 'Char'];
        return goodTypes.includes(type) ? 'good' : 'bad';
      };

      if (!location || location.trim() === '') return;

      try {
        const response = await axios.get(`https://core-c343.onrender.com/api/choghadiya?date=${formattedDate}&location=${encodeURIComponent(location)}`);
        const data = response.data;
        // console.log('Fetching data for date:', formattedDate, 'at', location);

        setDayMuhurta(
          data.dayChoghadiya.map(item => ({
            title: item.type,
            status: getStatus(item.type),
            time: `${item.start} to ${item.end}`,
          }))
        );

        setNightMuhurta(
          data.nightChoghadiya.map(item => ({
            title: item.type,
            status: getStatus(item.type),
            time: `${item.start} to ${item.end}`,
          }))
        );




        // Utility to parse time string like "12:00 PM" to total minutes
        const parseTimeToMinutes = (t) => {
          let [timePart, meridian] = t.trim().split(" ");
          let [hour, minute] = timePart.split(":").map(Number);
          if (meridian?.toLowerCase() === "pm" && hour !== 12) hour += 12;
          if (meridian?.toLowerCase() === "am" && hour === 12) hour = 0;
          return hour * 60 + minute;
        };

        const now = new Date();
        const nowMinutes = now.getHours() * 60 + now.getMinutes();

        const findCurrentChoghadiya = (choghadiyaList) => {
          return choghadiyaList.find((item) => {
            const [startStr, endStr] = item.time.split(" to ");
            const start = parseTimeToMinutes(startStr);
            const end = parseTimeToMinutes(endStr);

            if (end < start) {
              // Time spans across midnight
              return nowMinutes >= start || nowMinutes <= end;
            }
            return nowMinutes >= start && nowMinutes <= end;
          });
        };

        // Extract from mapped day/night data
        const currentSlot =
          findCurrentChoghadiya(
            data.dayChoghadiya.map(item => ({
              ...item,
              time: `${item.start} to ${item.end}`,
              status: getStatus(item.type),
              title: item.type
            }))
          ) ||
          findCurrentChoghadiya(
            data.nightChoghadiya.map(item => ({
              ...item,
              time: `${item.start} to ${item.end}`,
              status: getStatus(item.type),
              title: item.type
            }))
          );

        setCurrentChoghadiya(currentSlot || null);





      } catch (error) {
        console.error('Failed to fetch Choghadiya:', error);
      }
    };

    const debounce = setTimeout(fetchChoghadiya, 500);
    return () => clearTimeout(debounce);
  }, [currentDate, location]);



  const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

  const handleMonthClick = (monthIndex) => {
    const newDate = new Date(tempDate);
    newDate.setMonth(monthIndex);
    setTempDate(newDate);
  };

  const handleDayClick = (day) => {
    const newDate = new Date(tempDate);
    newDate.setDate(day);
    setTempDate(newDate);
  };

  const handleSubmit = () => {
    setCurrentDate(tempDate);
    setLocation(tempLocation);
  };

  const [selectedTile, setSelectedTile] = useState(null);

  const handleTileClick = (item, dayType) => {
    setSelectedTile({
      title: item.title,
      status: item.status,
      time: item.time,
      dayType: dayType,
      date: readableDate,
      weekday: weekDay,
      location: location,
      description: typeTooltips[item.title],
    });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

  const formatTime = (time, mode) => {
    if (!time || typeof time !== 'string') return "N/A";

    const [start, end] = time.split(" to ");

    const parseTime = (t) => {
      if (!t) return "N/A";
      const [hourMin, ampm] = t.trim().split(' ');
      let [hour, minute] = hourMin.split(':').map(Number);
      const isPM = ampm?.toLowerCase() === 'pm';

      if (mode === '12') {
        const suffix = isPM ? 'PM' : 'AM';
        hour = hour % 12 || 12;
        return `${hour}:${minute.toString().padStart(2, '0')} ${suffix}`;
      }

      if (mode === '24') {
        return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      }

      if (mode === '24Plus') {
        if (isPM && hour < 12) hour += 12;
        if (!isPM && hour === 12) hour = 0;
        return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      }

      return t;
    };

    return `${parseTime(start)} to ${parseTime(end)}`;
  };


  const formattedDate = currentDate.toISOString().split("T")[0];
  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });

  if (selectedTile) {
    return (
      <div className="Choghadiya-container">
        <InnerNav />

        <div className="Choghadiya-content">
          <button
            onClick={() => setSelectedTile(null)}
            style={{
              padding: "8px 14px",
              background: "#b35c00",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              width: "fit-content"
            }}
          >
            ← Back
          </button>

          <div className="Choghadiya-details">
            <h2>{selectedTile.title} Choghadiya</h2>

            <p style={{ fontSize: "1.05rem", marginBottom: "1rem" }}>
              This is a <b>{selectedTile.status === "good" ? "favorable" : "non-favorable"}</b> Choghadiya period
              occurring during the <b>{selectedTile.dayType.toLowerCase()}</b>.
            </p>

            <hr />

            <p>
              🕒 <b>Time Period</b><br />
              {formatTime(selectedTile.time, timeFormat)}
            </p>

            <p>
              📅 <b>Date</b><br />
              {selectedTile.date} ({selectedTile.weekday})
            </p>

            <p>
              📍 <b>Location</b><br />
              {selectedTile.location}
            </p>

            <hr />

            <p>
              🧿 <b>What does this mean?</b><br />
              {selectedTile.description}
            </p>

            <p style={{ marginTop: "1rem", fontStyle: "italic", color: "#555" }}>
              Tip: Choghadiya results may vary based on the purpose of work and personal horoscope.
            </p>

          </div>
        </div>

        <Footer />
      </div>
    );
  }


  return (
    <div className="Choghadiya-container">
      <InnerNav />
      <div className="Choghadiya-content">
        <Zodiac />
        <div className="Choghadiya-details">
          <div className="title">Choghadiya Muhurat Table</div>
          {/* <div className="sub">Running Do Ghati Muhurat</div> */}
          <div className="header">
            <div className="img-details">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRW3C3Ty79k_gyPc3OD5oWmoWQk5nXn1bGIYQ&s" alt="err" />
              <div className="right">
                <h3>Currently Running Choghadiya</h3>
                {currentChoghadiya ? (
                  <div className={`muhurta-card ${currentChoghadiya.status === 'good' ? 'green' : 'red'}`}>
                    <div className="title">
                      <p>{currentChoghadiya.title} ({currentChoghadiya.status})</p>
                    </div>
                    <div className="time">
                      {formatTime(currentChoghadiya.time, timeFormat)}
                    </div>
                  </div>
                ) : (
                  <p>No active Choghadiya at this moment.</p>
                )}

              </div>
            </div>
            <div className="date-display">
              <span className="day">{currentDate.getDate()}</span>
              <span className="month">{readableDate}</span>
            </div>
          </div>

          <div className="controls">
            <div className="mode-toggle">
              <button onClick={() => setTimeFormat("12")} className={timeFormat === "12" ? "active" : ""}>12 Hour</button>
              <button onClick={() => setTimeFormat("24")} className={timeFormat === "24" ? "active" : ""}>24 Hour</button>
              <button onClick={() => setTimeFormat("24Plus")} className={timeFormat === "24Plus" ? "active" : ""}>24 Plus</button>
            </div>

            <div className="month-grid">
              {months.map((month, i) => (
                <button key={i} onClick={() => handleMonthClick(i)}>{month}</button>
              ))}
            </div>

            <div className="day-grid">
              {Array.from({ length: 31 }, (_, i) => (
                <button key={i} onClick={() => handleDayClick(i + 1)}>{i + 1}</button>
              ))}
            </div>

            <div className="location-date">
              <div className="input-with-icon">
                <span className="icon">📍</span>
                <input
                  type="text"
                  value={tempLocation}
                  onChange={handleChange}
                  placeholder="Enter location"
                />
                {suggestions.length > 0 && (
                  <ul className="dropdown">
                    {suggestions.map((c, idx) => (
                      <li key={idx} onClick={() => handleSelect(c.city)}>
                        {c.city}, {c.state}, {c.country}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <input
                type="date"
                value={tempDate.toISOString().split("T")[0]}
                onChange={handleDateInput}
              />
              <button onClick={handlePrevDay}>Prev Day</button>
              <button onClick={handleNextDay}>Next Day</button>
              <button onClick={handleSubmit}>Submit</button>

            </div>
          </div>

          <div className="muhurta-section">
            <div className="muhurta-header">
              <div className="muhurta-date">{readableDate}, {weekDay}</div>
            </div>



            <div className="muhurta-columns">
              <div className="muhurta-column day">
                <span>🌞 Day Choghadiya Division </span>
                {dayMuhurta.map((item, idx) => (
                  <div
                    key={idx}
                    className={`muhurta-card ${item.status === 'good' ? 'green' : 'red'}`}
                    onClick={() => handleTileClick(item, "Day")}
                    style={{ cursor: "pointer" }}
                  >

                    <div className="caerdds">
                      <div className="tooltip-wrapper">
                        <div className="title">{item.title} ({item.status})</div>
                        <span className="tooltip-text">{typeTooltips[item.title] || "No info available"}</span>
                      </div>


                    </div>
                    <div className="time">{formatTime(item.time, timeFormat)}</div>
                  </div>
                ))}
              </div>

              <div className="muhurta-column night">
                <span> 🌜 Night Choghadiya Division </span>
                {nightMuhurta.map((item, idx) => (
                  <div
                    key={idx}
                    className={`muhurta-card ${item.status === 'good' ? 'green' : 'red'}`}
                    onClick={() => handleTileClick(item, "Night")}
                    style={{ cursor: "pointer" }}
                  >

                    <div className="caerdds">
                      <div className="tooltip-wrapper">
                        <div className="title">{item.title} ({item.status})</div>
                        <span className="tooltip-text">{typeTooltips[item.title] || "No info available"}</span>
                      </div>

                    </div>
                    <div className="time">{formatTime(item.time, timeFormat)}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <section className="choghadiya-wrapper">
          <h1 className="choghadiya-title">About Choghadiya</h1>
          <div className="choghadiya-texts">
            <p>
              <strong>Choghadiya or Chogadia</strong> is used for checking auspicious time to start new work. Traditionally Choghadiya is used for travel muhurthas but due to its simplicity, it is used for any muhurtha.
            </p>

            <p>
              There are four good Choghadiya, <strong>Amrit, Shubh, Labh</strong> and <strong>Char</strong>, to start an auspicious work. Three bad Choghadiya, <strong>Rog, Kaal</strong> and <strong>Udveg</strong>, should be avoided.
              The time between sunrise and sunset is called <strong>day Choghadiya</strong> and the time between sunset and next day sunrise is called <strong>night Choghadiya</strong>.
            </p>

            <h2>About Vaar Vela, Kaal Vela and Kaal Ratri</h2>
            <p>
              It is believed that no auspicious work should be done during <strong>Vaar Vela, Kaal Vela</strong> and <strong>Kaal Ratri</strong>. Vaar Vela and Kaal Vela prevail during daytime while Kaal Ratri prevails during night time.
              It is believed that all Manglik works done during these timings are not fruitful.
            </p>

            <h2>Why Choghadiya Name?</h2>
            <p>
              In Hindu division of the day, the time between Sunrise to Sunset is divided into 30 Ghati. For Choghadiya Muhurta, the same time duration is divided into 8 parts,
              which results in 8 Choghadiya Muhurta during the daytime as well as during the night time. As each Choghadiya Muhurta approximates to 4 Ghati, it is known as Choghadiya i.e.
              Choghadiya = Cho (four) + Ghadiya (Ghati). Choghadiya Muhurta is also known as <strong>Chaturshtika Muhurta</strong>.
            </p>

            <h2>What if auspicious Choghadiya overlaps with
              <Link to="/muhurat/rahu-kala"
                style={{ textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px' }}>
                Rahu Kala?
              </Link>
            </h2>
            <p>
              It is quite possible that auspicious Choghadiya might overlap with <strong>Rahu Kala</strong>. Rahu Kala is considered highly malefic. In south India, it is given utmost importance while selecting any Muhurta.
              Although many authoritative works on Muhurta don't have reference to Rahu Kala, it is always better to abandon that auspicious Choghadiya Muhurta which overlaps with Rahu Kala.
            </p>

            <h2>What if auspicious Choghadiya overlaps with Vara, Kala and Ratri Vela?</h2>
            <p>
              It is quite possible that auspicious Choghadiya might overlaps with Vara Vela, Kala Vela and Kala Ratri. While selecting Choghadiya Muhurta, the adverse time of Vara Vela, Kala Vela and Kala Ratri should be rejected.
              It is believed that all Manglik works done during Vara Vela, Kala Vela and Kala Ratri are not fruitful and don't give the desired results.
            </p>

            <h2>How to mark Choghadiya Good or Bad?</h2>
            <p>
              The first Muhurta on each weekday is ruled by the weekday lord. For example, on Sunday, the first Choghadiya Muhurta is ruled by the Sun followed by Venus, Mercury, Moon, Saturn, Jupiter and Mars respectively.
              The last Muhurta of the daytime is also ruled by the day lord.
            </p>

            <p>
              Hence the effect of each division, either bad or good, is marked based on the nature of the ruling planet. In Vedic Astrology,
              the time period under the influence of Venus, Mercury, Moon and Jupiter is usually considered auspicious while the time period under the influence of Sun, Mars and Saturn is usually considered inauspicious.
              Based on the above information, we can mark each Choghadiya Muhurta as bad or good.
              It should be noted that bad Choghadiya can also be appropriate depending on the desired work which needs to be accomplished.
            </p>

            <h2>Udveg Choghadiya</h2>
            <p>
              The Sun is considered a malefic planet in Vedic astrology. Hence the time under the influence of it is usually considered inauspicious and marked as <strong>Udveg</strong>.
              However, for government-related work, Udveg Choghadiya is considered good.
            </p>

            <h2>Char Choghadiya</h2>
            <p>
              The Venus is considered a benefic planet in Vedic astrology. Hence the time under the influence of it is considered auspicious and marked as <strong>Char</strong> or <strong>Chanchal</strong>.
              Due to the moving nature of the Venus, Char Choghadiya is considered most appropriate for travelling purpose.
            </p>

            <h2>Labh Choghadiya</h2>
            <p>
              The Mercury is considered a benefic planet in Vedic astrology. Hence the time under the influence of it is considered auspicious and marked as <strong>Labh</strong>.
              Labh Choghadiya is considered most appropriate to start education and to acquire new skills.
            </p>

            <h2>Amrit Choghadiya</h2>
            <p>
              The Moon is usually considered a benefic planet in Vedic astrology. Hence the time under the influence of it is considered auspicious and marked as <strong>Amrit</strong>.
              Amrit Choghadiya is considered good for all type of works.
            </p>

            <h2>Kala Choghadiya</h2>
            <p>
              The Saturn is considered a malefic planet in Vedic astrology. Hence the time under the influence of it is considered inauspicious and marked as <strong>Kala</strong>.
              No auspicious work is done during Kala Choghadiya. However, Kala Choghadiya is recommended for those activities which are performed to accumulate wealth.
            </p>

            <h2>Shubh Choghadiya</h2>
            <p>
              The Jupiter is considered a benefic planet in Vedic astrology. Hence the time under the influence of it is considered auspicious and marked as <strong>Shubh</strong>.
              Shubh Choghadiya is considered good to conduct ceremonies especially marriage ceremony.
            </p>

            <h2>Rog Choghadiya</h2>
            <p>
              The Mars is considered a malefic planet in Vedic astrology. Hence the time under the influence of it is considered inauspicious and marked as <strong>Rog</strong>.
              No auspicious work is done during Rog Choghadiya. However, Rog Choghadiya is recommended for war and to defeat the enemy.
            </p>
          </div>
        </section>

        <MuhuratLink />
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Choghadiya;
